import type { FC } from 'react';
import React from 'react';

import classNames from 'classnames';

import type { IItem } from '@admin/types/item';

import { ItemBrick } from './item_brick';
import { SelectableBrick } from './selectable_brick';

const ENTRY_CLASS = 'entry';

export interface ItemsGridProps {
  items: IItem[];
  selections?: IItem[];
  onSelect?: (selections: IItem[]) => void;
  isSizeable?: boolean;
  categoryBulkEditMode?: boolean;
  className?: string;
}

export const ItemsGrid: FC<ItemsGridProps> = ({
  items,
  selections,
  onSelect,
  isSizeable = false,
  categoryBulkEditMode,
  className = 'col-xs-6 col-sm-4 col-md-3 col-lg-2',
}) => (
  <div className="grid">
    <div className="row">
      {items.map((item) => (
        <div key={item.id} className={classNames(ENTRY_CLASS, className)}>
          {selections && onSelect ? (
            <SelectableBrick selection={item} selections={selections} onSelect={onSelect} />
          ) : (
            <ItemBrick item={item} sizeable={isSizeable} categoryBulkEditMode={categoryBulkEditMode} />
          )}
        </div>
      ))}
    </div>
  </div>
);
